export const BRAND_ACTIVATED = 'activated';
export const BRAND_ACTION_REQUIRED = 'action_required';
export const BRAND_PENDING = 'pending';
export const BRAND_ACCEPT_INVITATION = 'accept_invitation';
